import { adkitApi } from "../adkitApi";
import type { SluggedId } from "Models";
import type {
  CreateAdKitLocationInstanceDto,
  UpdateAdLocationInstanceWithIdDto,
} from "entities/requests/adkit";

type LocationArgs = {
  facilityId: string;
  adKitId: SluggedId;
  locationId: SluggedId;
};
type AddInstanceArgs = LocationArgs & {
  body: CreateAdKitLocationInstanceDto[];
};
type UpdateInstanceArgs = LocationArgs & {
  instanceId: SluggedId;
  body: unknown;
};
type UpdateInstancesArgs = LocationArgs & {
  body: UpdateAdLocationInstanceWithIdDto[];
};
type DeleteInstanceArgs = LocationArgs & { instanceId: SluggedId };

const instanceEndpoints = adkitApi.injectEndpoints({
  endpoints: (build) => ({
    addAdKitInstance: build.mutation<unknown, AddInstanceArgs>({
      query: ({ facilityId, adKitId, locationId, body }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/location/${locationId}/instances`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
      ],
    }),

    updateAdKitInstance: build.mutation<unknown, UpdateInstanceArgs>({
      query: ({ facilityId, adKitId, locationId, instanceId, body }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/location/${locationId}/instance/${instanceId}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
      ],
    }),

    updateAdKitInstancesByLocation: build.mutation<
      unknown,
      UpdateInstancesArgs
    >({
      query: ({ facilityId, adKitId, locationId, body }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/location/${locationId}/instances`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
      ],
    }),

    deleteAdKitInstance: build.mutation<unknown, DeleteInstanceArgs>({
      query: ({ facilityId, adKitId, locationId, instanceId }) => ({
        url: `/api/ad-kit/facility/${facilityId}/adkit/${adKitId}/location/${locationId}/instance/${instanceId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_r, _e, { adKitId }) => [
        { type: "AdKit", id: adKitId },
      ],
    }),
  }),
});

export const {
  useAddAdKitInstanceMutation,
  useUpdateAdKitInstanceMutation,
  useUpdateAdKitInstancesByLocationMutation,
  useDeleteAdKitInstanceMutation,
} = instanceEndpoints;
